/** See `src/i18n/locales/en/manageSupport.ts`. */
export const manageSupport = {
  page: {
    title: 'Soporte',
    lead: 'Todos los tickets de soporte de la plataforma, filtrables por estado y prioridad.',
    filterStatus: 'Estado',
    filterPriority: 'Prioridad',
    allStatuses: 'Todos los estados',
    allPriorities: 'Todas las prioridades',
    empty: 'Ningún ticket coincide con estos filtros.',
    rowsLabel: 'los tickets',
    subject: 'Asunto',
    company: 'Empresa',
    status: 'Estado',
    priority: 'Prioridad',
    createdAt: 'Abierto',
  },
  status: {
    open: 'Abierto',
    in_progress: 'En curso',
    resolved: 'Resuelto',
    closed: 'Cerrado',
  },
  priority: {
    low: 'Baja',
    normal: 'Normal',
    high: 'Alta',
    urgent: 'Urgente',
  },
  detail: {
    thisTicket: 'este ticket',
    requesterTitle: 'Solicitante',
    requesterLabel: 'el solicitante',
    controlsTitle: 'Estado y prioridad',
    save: 'Guardar',
    threadTitle: 'Conversación',
    threadEmpty: 'Todavía no hay mensajes.',
    replyLabel: 'Respuesta',
    reply: 'Enviar respuesta',
  },
} as const;
